import * as React from 'react';
import { Header, Navigation, Footer, Filter } from '../../shared';

import './MarketSharesBookstore.scss';

import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { Grid, Typography, Tab, AppBar, Tabs, LinearProgress, Menu, MenuItem } from "@material-ui/core";
import { MarketShareBookstoreShare } from './marketShare/MarketShareBookstoreShare';
import {MarketShareBookstoreCategory} from './categoryShare/MarketShareBookstoreCategory';
import { MarketBookstoreStoreFilter } from './shared/filter/bookstore/MarketBookstoreStoreFilter';
import { MarketBookstoreChip } from './shared/chips/MarketBookstoreChip';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import { MarketShareBookstoreCategoryAnalytical } from './categoryShare/analytical/MarketShareBookstoreCategoryAnalytical';
import { MarketShareBookstoreCategoryRanking } from './categoryShare/ranking/MarketShareBookstoreCategoryRanking';

// tslint:disable-next-line:no-empty-interface
export interface IMarketSharesBookstoreProps {
}

// tslint:disable-next-line:no-empty-interface
export interface IMarketSharesBookstoreState {
    anchorElBookstore?: HTMLElement;
    anchorElCategory?: HTMLElement;
    economicGroups: any[];
    loading: boolean;
    marketProviderFilterChecked: string[];
    marketStampFilterChecked: string[];
    bookstoreMenuValue: number;
    bookstoreItemMenuName: string;
    categoryMenuValue: number;
    categoryItemMenuName: string;
    shareBookstoreMenuOpen: boolean;
    shareCategoryMenuOpen: boolean;
    tabValue: number;
}

function TabContainer(props: any) {
    return (
        <Typography component="div" style={{ paddingTop: 8 * 3 }}>
            {props.children}
        </Typography>
    );
}

function LinkTab(props: any) {
    return (
      // tslint:disable-next-line:jsx-no-lambda
      <Tab className="marketBookstoreTab" onClick={event => event.preventDefault()} {...props} />
    );
}

export class MarketSharesBookstore extends React.Component<IMarketSharesBookstoreProps, IMarketSharesBookstoreState> {
    constructor(props: IMarketSharesBookstoreProps) {
        super(props);

        this.state = {
            anchorElBookstore: undefined,
            anchorElCategory: undefined,
            bookstoreItemMenuName: 'Consolidado',
            bookstoreMenuValue: 0,
            categoryItemMenuName: '',
            categoryMenuValue: 0,
            economicGroups: [],
            loading: false,
            marketProviderFilterChecked: [],
            marketStampFilterChecked: [],
            shareBookstoreMenuOpen: false,
            shareCategoryMenuOpen: false,
            tabValue: 0,
        };
    }

    public render() {
        
        const { anchorElBookstore, anchorElCategory, loading } = this.state;

        let bookstoreTabName = "Livraria";
        if(this.state.bookstoreItemMenuName && this.state.bookstoreItemMenuName.length > 0) {
            bookstoreTabName += (' - ' +this.state.bookstoreItemMenuName);
        }
        
        let categoryTabName = "Categorias";
        if(this.state.categoryItemMenuName && this.state.categoryItemMenuName.length > 0) {
            categoryTabName += (' - ' +this.state.categoryItemMenuName);
        }

        return (
            <div>
                
                <div className="marketBookstorePanel"> 
                    <Header
                        title={"Painel de Mercado Livrarias"}
                        name={"Mercado"}
                        link={'/dashboard'}
                    />
                    <Navigation
                        name={"Mercado"}
                        linkDefault={"/market/shares"}
                        link={"/publisher/analytical"}
                        linkTitle={"Produtos"}
                        painel={3}
                        icon={<ChevronRightIcon />}
                        economicGroups={this.state.economicGroups}
                    />
                    <Filter filters={[
                        <MarketBookstoreStoreFilter key={1} />
                    ]} />

                    <MarketBookstoreChip />

                    {loading ? <LinearProgress /> :
                    <div className="wrapper">
                        <AppBar position="static" style={{ backgroundColor: '#FFFF' }}>
                            <Tabs fullWidth={true} value={this.state.tabValue} onChange={this.handleChangeTab} 
                                centered={true} textColor="primary" indicatorColor="primary">

                                <LinkTab 
                                    icon={this.state.shareBookstoreMenuOpen ?  <ExpandLess /> : <ExpandMore />}
                                    label={bookstoreTabName} 
                                    onClick={this.handleShareBookstoreClick}
                                />
                                <LinkTab 
                                    icon={this.state.shareCategoryMenuOpen ?  <ExpandLess /> : <ExpandMore />} 
                                    label={categoryTabName} 
                                    onClick={this.handleShareCategoriesClick} 
                                />
                                <LinkTab label="Analítico" />
                                <LinkTab label="Ranking" />

                                <Menu
                                    className="share-editora-options"
                                    anchorEl={anchorElBookstore}
                                    open={Boolean(anchorElBookstore)}
                                    onClose={this.handleShareBookstoreMenuClose}
                                >
                                    <MenuItem onClick={this.handleShareBookstoreMenuChoose.bind(this, 0, 'Consolidado')} >
                                        Consolidado
                                    </MenuItem>
                                    <MenuItem onClick={this.handleShareBookstoreMenuChoose.bind(this, 1, 'Evolução')} >
                                        Evolução
                                    </MenuItem>
                                </Menu>

                                <Menu
                                    className="share-editora-options"
                                    anchorEl={anchorElCategory}
                                    open={Boolean(anchorElCategory)}
                                    onClose={this.handleShareCategoriesMenuClose}
                                >
                                    <MenuItem onClick={this.handleShareCategoriesMenuChoose.bind(this, 0, '')} >
                                        Categorias
                                    </MenuItem>
                                    <MenuItem onClick={this.handleShareCategoriesMenuChoose.bind(this, 1, 'Subcategoria')} >
                                        Subcategorias
                                    </MenuItem>
                                </Menu>
                                
                            </Tabs>
                        </AppBar>
                        {this.state.tabValue === 0 && <TabContainer>
                            <Grid container={true} className="publisher-sale-panel panel-grid" spacing={16} >
                                <Grid item={true} xs={12} md={12} className="market-share-panel">
                                    <MarketShareBookstoreShare bookstoreMenuValue={this.state.bookstoreMenuValue} />
                                </Grid>
                            </Grid>
                        </TabContainer>}
                        {this.state.tabValue === 1 && <TabContainer>
                            <Grid container={true} className="publisher-sale-panel panel-grid" spacing={16} >
                                <Grid item={true} xs={12} md={12} className="market-share-panel">                                    
                                    <MarketShareBookstoreCategory categoryMenuValue={this.state.categoryMenuValue} />
                                </Grid>
                            </Grid>
                        </TabContainer>}
                        {this.state.tabValue === 2 && <TabContainer>
                            <Grid container={true} className="publisher-sale-panel panel-grid" spacing={16} >
                                <Grid item={true} xs={12} md={12} className="market-share-panel">                                    
                                    <MarketShareBookstoreCategoryAnalytical />
                                </Grid>
                            </Grid>
                        </TabContainer>}
                        {this.state.tabValue === 3 && <TabContainer>
                            <Grid container={true} className="publisher-sale-panel panel-grid" spacing={16} >
                                <Grid item={true} xs={12} md={12} className="market-share-panel">                                    
                                    <MarketShareBookstoreCategoryRanking />
                                </Grid>
                            </Grid>
                        </TabContainer>}
                    </div>}
                    <Footer />
                </div>
            
            </div>
        );
    }


    private handleChangeTab = (event: any, tabValue: any) => {
        if(tabValue !== 1 && tabValue !== 0) {
            this.setState({ tabValue });
        }
        
        event.stopPropagation();
    };

    private handleShareCategoriesClick = (event: React.MouseEvent<HTMLElement>) => {
        event.stopPropagation();
        this.setState({ anchorElCategory: event.currentTarget, shareCategoryMenuOpen: !this.state.shareCategoryMenuOpen });
    };

    private handleShareCategoriesMenuClose = () => {
        this.setState({ anchorElCategory: undefined, shareCategoryMenuOpen: false });
    }

    private handleShareCategoriesMenuChoose = (categoryMenuValue: number, categoryItemMenuName: string) => {
        this.setState({ categoryItemMenuName, categoryMenuValue, anchorElCategory: undefined, shareCategoryMenuOpen: false, tabValue: 1 });
    };

    /**
     * Gerencia Tab Livraria
     */
    private handleShareBookstoreClick = (event: React.MouseEvent<HTMLElement>) => {
        event.stopPropagation();
        this.setState({ anchorElBookstore: event.currentTarget, shareBookstoreMenuOpen: !this.state.shareBookstoreMenuOpen });
    };

    private handleShareBookstoreMenuClose = () => {
        this.setState({ anchorElBookstore: undefined, shareBookstoreMenuOpen: false });
    }

    private handleShareBookstoreMenuChoose = (bookstoreMenuValue: number, bookstoreItemMenuName: string) => {
        this.setState({ 
            anchorElBookstore: undefined, 
            bookstoreItemMenuName, 
            bookstoreMenuValue, 
            shareBookstoreMenuOpen: false, 
            tabValue: 0 
        });
    };

}



// WEBPACK FOOTER //
// ./src/component/market/bookstore/MarketSharesBookstore.tsx